import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { BtnExtComponent, TableWrapComponent } from "@app/utils/utils.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { AddMeetingRequestComponent } from "@app/add-meeting-request/add-meeting-request.component"
import { ChoosePartnerComponent } from "@app/choose-partner/choose-partner.component"
import { InsertPatientFormComponent } from "@app/insert-patient-form/insert-patient-form.component"
import { ConfirmComponent } from "@app/confirm/confirm.component"

@Component({
	selector: "app-mr-motions",
	imports: [
		COMMON_IMPORTS,
		GenButtonGroupComponent,
		TableWrapComponent,
		LangValPipe,
		DateFormatPipe,
		BtnExtComponent,
		ModalWrapComponent,
		AddMeetingRequestComponent,
		ChoosePartnerComponent,
		InsertPatientFormComponent,
		ConfirmComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./mr-motions.component.html",
})
export class MrMotionsComponent extends Modalable {
	modalProps: any = null
	ownerHasUsers: boolean = false
	rows: any[] = []
	displayRows: any[] = []
	status: string = "0"

	async ngOnInit() {
		this.ownerHasUsers = this.permsService.owner_has_users
		this.loadData()
	}

	async loadData() {
		const res = await this.apiService.post("get_mr_motions_rows")
		this.rows = res.rows

		if (this.ownerHasUsers) {
			this.store.removeDecArr(this.rows)
			this.rows.forEach((row) => {
				if (row?.motions?.length) {
					row.motions.forEach((motion) => {
						this.assignUserToMotion(motion)
					})
				}
			})
		} else {
			this.rows.forEach((row) => {
				if (row?.mr) {
					this.assignUserToMotion(row.mr)
					this.store.removeDecItem(row.mr)
				}
			})
		}
		this.filterRows()
	}

	assignUserToMotion(motion: any) {
		motion.user =
			this.store.searchSiteDataItem(motion.user_id, ["partners"])?.name || ""
	}
	async handleChoosePartnerClose(row: any, res: any[]) {
		if (res?.length != 1) {
			return
		}
		row.sendingToPartner = true
		const res2 = await this.apiService.post("send_mr_to_partner", {
			mr_id: row.id,
			user_id: res[0].id,
		})
		row.sendingToPartner = false
		if (res2?.motion) {
			this.assignUserToMotion(res2.motion)
			row.motions = [...row.motions, res2.motion]
			row.status = "directed"
			this.modalService.openToast("directed")
		}
	}
	choosePartner(row: any) {
		this.modalProps = { name: "choose-partner", row }
	}

	filterRows() {
		if (this.status == "0") {
			this.displayRows = this.rows
		} else {
			this.displayRows = this.rows.filter((row) => row.status == this.status)
		}
	}

	async sendResponse(row: any, is_checking: boolean) {
		const fieldName = is_checking ? "isCheckingSend" : "isRejectingSend"
		row[fieldName] = true
		const res = await this.apiService.post("mr_partner_response", {
			mr_motion_id: row.id,
			is_checking,
		})
		row[fieldName] = false
		this.modalService.openToast(is_checking ? "checking" : "declined")
		if (res?.success) {
			row.status = is_checking ? "checking" : "declined"
		}
		if (!is_checking) {
			this.rows = this.rows.filter((r) => r.id != row.id)
		}
	}
	handleConfirmAccept(approved: boolean) {
		this.modalProps = approved
			? { ...this.modalProps, name: "insert-patient-form" }
			: null
	}
	async acceptPatient(row: any) {
		this.modalProps = { name: "confirm-accept-patient", row }
	}
	async handleInsertPatientClose(newPatient: any) {
		const { row } = this.modalProps
		if (!newPatient) {
			return
		}

		row.isAcceptSending = true
		await this.apiService.post("mr_partner_accept", { mr_motion_id: row.id })
		row.isAcceptSending = false
		row.status = "accepted"
	}
}
